export default "__VITE_ASSET__DgqcTcDP__"